import { DataManager } from "../model/DataManager.js";
import { DateUtil } from "../model/DateUtil.js";
import { Language, Translation } from "../model/Language.js";
import { BaseElement, BaseElementOptions } from "./BaseElement.js";

export interface HeadlineOptions extends BaseElementOptions {
    assetsUrl: string;
    data: DataManager;
    date: Date;
}

export class Headline extends BaseElement {

    public readonly element: HTMLDivElement;

    private _data: DataManager;
    private _distance: HeadlineItem;
    private _airTemperature: HeadlineItem;
    private _windSpeed: HeadlineItem;

    public create(options: HeadlineOptions):this {

        super.create(options);

        this.setElement(this.createElement());

        this.element.innerHTML = `
        <div class="awi-headline__fade awi-headline__fade--start"></div>
        <div class="awi-headline__fade awi-headline__fade--end"></div>
        <div class="awi-headline__content"></div>
        `;

        this._data = options.data;

        this._distance = this.addItem({
            value: "1524",
            icon: "fal fa-ruler-vertical",
            label: {
                de: "Strecke",
                en: "Distance"
            },
            unit: {
                de: "km"
            }
        });

        this._airTemperature = this.addItem({
            value: "12.1",
            icon: "fal fa-thermometer-half",
            label: {
                de: "Lufttemperatur",
                en: "Air temperature"
            },
            unit: {
                de: "°C"
            }
        });

        this._windSpeed = this.addItem({
            value: "4.3",
            icon: "fal fa-windsock",
            label: {
                de: "Windgeschwindigkeit",
                en: "Wind speed"
            },
            unit: {
                de: "m/s"
            }
        });

        options.container.appendChild(this.element);

        this.setDate(options.date);

        return this;
    }

    protected createElement(): HTMLDivElement {
        var e = document.createElement("div");
        e.className = "awi-headline";
        return e;
    }

    private addItem(options: HeadlineItemOptions): HeadlineItem {
        var item = new HeadlineItem(options);
        this.element.querySelector(".awi-headline__content").appendChild(item.element);
        return item;
    }

    public setDate(date: Date): void {
        var day = this._data.getDay(date);
        if (!day) {
            return;
        }

        // var sensor = day.nearest;

        // if (DateUtil.compare(day.nearest.date, date) !== 0) {
        //     sensor = null;
        //     sensor = day.sensors[0];
        // }

        var sensor = day.sensor;

        if (!sensor) {
            this._distance.value = "";
            this._airTemperature.value = "";
            this._windSpeed.value = "";
        } else {

            this._distance.value = sensor.distance === null ? "" : Math.floor(sensor.distance) + "";
            this._airTemperature.value = sensor.temperature === null ? "" : sensor.temperature.toFixed(1);
            this._windSpeed.value = sensor.wind === null ? "" : sensor.wind.toFixed(1);
        }

    }
}

export interface HeadlineItemOptions {
    value?: string;
    unit: Translation;
    label: Translation;
    icon: string;
}

export class HeadlineItem {

    public readonly element: HTMLDivElement;

    private _value: HTMLSpanElement;
    private _unit: HTMLSpanElement;

    constructor(options: HeadlineItemOptions) {
        this.element = document.createElement("div");
        this.element.className = "awi-headline__item";

        var left = document.createElement("div");
        left.className = "awi-headline__item-left";
        this.element.appendChild(left);

        var icon = document.createElement("div");
        icon.className = "awi-headline__item-icon " + options.icon;
        left.appendChild(icon);

        var right = document.createElement("div");
        right.className = "awi-headline__item-right";
        this.element.appendChild(right);

        var line = document.createElement("div");
        line.className = "awi-headline__item-line";
        right.appendChild(line);

        this._value = document.createElement("span");
        this._value.className = "awi-headline__item-value";
        line.appendChild(this._value);

        var unit = document.createElement("span");
        unit.className = "awi-headline__item-unit";
        lang.set(unit, options.unit);
        line.appendChild(unit);
        this._unit = unit;

        var label = document.createElement("div");
        label.className = "awi-headline__item-label";
        lang.set(label, options.label);
        right.appendChild(label);

        if (options.value) {
            this.value = options.value;
        }
    }

    public get value(): string {
        return this._value.textContent;
    }

    public set value(value: string) {
        this._unit.classList.toggle("e5-hidden", !Boolean(value));
        if (!value) {
            value = "--";
        }
        this._value.textContent = value;
    }
}